import Button, { ButtonProps } from '@mui/material/Button';

const CustomButton = (
  { variant, disableElevation = false, buttonSize, label, ...props }: any) => {

  return (
    <Button
      variant={variant}
      disableElevation={disableElevation}
      className={`btn ${buttonSize} ${
        variant === 'contained' ? 'green-btn' : 'border-btn'
      }`}
      classes={{ disabled: 'btn-disabled' }}
      {...props}
    >
      {label}
    </Button>
  );
};

export default CustomButton;